<template>
	<PopupRouterView :showLeftIcon="true" label="Approval Group Input"  entityName="approvalgroup" :documentId="mainRecordId"  @saveMethod="saveActionConfirmation" @hideMethod="onHidden">
		<b-card  header="Approval Group Data" class="mb-3 card-max-width">
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-name" label-cols-sm="12" label="Name" label-for="input-name" size="sm" :model.sync="model.name"   />
				<app-input-textarea id="fieldset-description" label-cols-sm="12" label="Description" label-for="input-description" size="sm" :model.sync="model.description"   />
			</b-col>
		</b-card>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :model="model" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ApprovalGroup from '@/models/ApprovalGroup/ApprovalGroup';
import ApprovalGroupList from '@/models/ApprovalGroup/ApprovalGroupList';
import ApprovalGroupFilter from '@/filters/ApprovalGroup/ApprovalGroupFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,AppInputTextarea,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterApprovalGroup : null,
			currentApprovalGroupPage : 1,
			approvalGroupPageSize: 10,
			sortByApprovalGroup: '',
			sortDescApprovalGroup: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getApprovalGroup : async function(id) {
			this.isBusy = true;
			ApprovalGroup.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadApprovalGroup = true;
			this.filterApprovalGroup.id = this.modelId;
			ApprovalGroup.downloadDataDetail(this, this.filterApprovalGroup).then(result => {
				this.isDownloadApprovalGroup = false;
			}).catch(error => { this.isDownloadApprovalGroup = false; })
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				ApprovalGroup.updateData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'approvalgroupindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			} else {
				ApprovalGroup.insertData(this, model).then(result => {
					this.$router.push({ name: 'approvalgroupindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		onHidden() {
			this.getApprovalGroups();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterApprovalGroup = new ApprovalGroupFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getApprovalGroup(id);
			} else {
				this.modelId = id;
				this.getApprovalGroup(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
	},
}
</script>
